/**
 * UserSessionProgressService
 * Per-user per-session completion marker + resume position.
 * Route: api/user-session-progress
 */
import { BaseService } from '../base/BaseService';
export class UserSessionProgressService extends BaseService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? UserSessionProgressService.DEFAULT_SERVICE_PATH,
            basePath: UserSessionProgressService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    /** My session-level progress across a single course (feeds the curriculum drawer). */
    async getMineForCourse(courseId) {
        const response = await this.getMineForCourseRaw(courseId);
        return response.data ?? [];
    }
    getMineForCourseRaw(courseId) {
        return this.http.get(this.buildUrl(`me/course/${courseId}`));
    }
    /** My progress row for a single session (feeds the resume marker). */
    async getMineForSession(sessionId) {
        const response = await this.getMineForSessionRaw(sessionId);
        return response.data ?? null;
    }
    getMineForSessionRaw(sessionId) {
        return this.http.get(this.buildUrl(`me/session/${sessionId}`));
    }
    /** Admin: all learners' rows for a session. */
    async getForSession(sessionId) {
        const response = await this.getForSessionRaw(sessionId);
        return response.data ?? [];
    }
    getForSessionRaw(sessionId) {
        return this.http.get(this.buildUrl(`session/${sessionId}`));
    }
    async upsert(item) {
        const response = await this.upsertRaw(item);
        return response.data ?? null;
    }
    upsertRaw(item) {
        return this.http.post(this.buildUrl(''), item);
    }
    async delete(id) {
        const response = await this.deleteRaw(id);
        return response.success;
    }
    deleteRaw(id) {
        return this.http.delete(this.buildUrl(`${id}`));
    }
}
UserSessionProgressService.DEFAULT_SERVICE_PATH = 'resources';
UserSessionProgressService.BASE_PATH = 'api/user-session-progress';
//# sourceMappingURL=UserSessionProgressService.js.map